import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, input, output } from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';

import { Filter } from 'ish-core/models/filter/filter.model';

@Component({
  selector: 'ish-filter-collapsible',
  templateUrl: './filter-collapsible.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, FaIconComponent],
})
export class FilterCollapsibleComponent implements OnInit {
  readonly filterElement = input.required<Filter>();
  readonly collapsed = input<boolean>(undefined);
  readonly collapsedChange = output<boolean>();

  isCollapsed = false;

  ngOnInit() {
    this.isCollapsed = this.collapsed();
  }

  toggle() {
    this.isCollapsed = !this.isCollapsed;
    this.collapsedChange.emit(this.isCollapsed);
  }
}
